export let isElectronApp = () => {
  if (!window.require) {
    return false;
  }

  if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') {
    return true;
  }

  if (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) {
    return true;
  }

  return (
    typeof navigator === 'object' &&
    typeof navigator.userAgent === 'string' &&
    navigator.userAgent.indexOf('Electron') >= 0
  );
};

export let requireFromElectron = dependency => {
  if (isElectronApp() && window.require) {
    return window.require(dependency);
  }
  return;
};

export let requireFromElectronRemote = dependency => {
  if (isElectronApp()) {
    const electron = requireFromElectron('electron');
    return electron.remote.require(dependency);
  }
};

export let getElectronApp = () => {
  if (isElectronApp()) {
    const electron = requireFromElectron('electron');
    return electron.remote.app;
  }
};

/// @see https://github.com/wictorwilen/msteams-react-base-component/blob/c3d941e3467365c23d8e8f4f2c067c4b0eb6a032/src/useTeams.ts#L18
export const isEmbbededInTeams = () => {
  if (
    (window.parent === window.self && window.nativeInterface) ||
    window.navigator.userAgent.includes('Teams/') ||
    window.navigator.userAgent.includes('MicrosoftTeams') ||
    window.name === 'embedded-page-container' ||
    window.name === 'extension-tab-frame'
  ) {
    return true;
  }
  return false;
};
